export const ACTIVE_TAB_SET = 'iCalendar/feeds/ACTIVE_TAB_SET'
export const ALL_FEEDS_LIST_SET = 'iCalendar/feeds/ALL_FEEDS_LIST_SET'
export const FEED_ADD = 'iCalendar/feeds/FEEDS_ADD'
export const SHARED_FEEDS_LIST_SET = 'iCalendar/feeds/SHARED_FEEDS_LIST_SET'
export const FEED_REMOVE = 'iCalendar/feeds/FEED_REMOVE'
export const LOADING_SET = 'iCalendar/feeds/LOADING_SET'
export const ALL_SORTING_SET = 'iCalendar/feeds/ALL_SORTING_SET'
export const SHARED_SORTING_SET = 'iCalendar/feeds/SHARED_SORTING_SET'
export const RECENTLY_CONFIGURED_FEED_ID_SET = 'iCalendar/feeds/RECENTLY_CONFIGURED_FEED_ID'
export const FEEDS_CONTENT_LOADING_SET = 'iCalendar/feeds/FEEDS_CONTENT_LOADING_SET'

export const RENGERATE_FEED_LINK_DATA_LOAD = 'iCalendar/feeds/REGENERATE_FEED_LINK_DATA_LOAD'
export const RENGERATE_FEED_LINK_DATA_LOAD_SUCCESS = 'iCalendar/feeds/REGENERATE_FEED_LINK_DATA_LOAD_SUCCESS'
export const RENGERATE_FEED_LINK_DATA_LOAD_FAILURE = 'iCalendar/feeds/REGENERATE_FEED_LINK_DATA_LOAD_FAILURE'

export const DELETE_FEED_DATA_LOAD = 'iCalendar/feeds/DELETE_FEED_DATA_LOAD'
export const DELETE_FEED_DATA_LOAD_SUCCESS = 'iCalendar/feeds/DELETE_FEED_DATA_LOAD_SUCCESS'
export const DELETE_FEED_DATA_LOAD_FAILURE = 'iCalendar/feeds/DELETE_FEED_DATA_LOAD_FAILURE'



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/actionTypes.js